module.exports = __webpack_public_path__ + "img/315.fb2930d2.png";